function formatNumber(number, options = {}) {
  const {
    decimals = 2,
    roundingType = 'round',
    thousandsSeparator = ' ',
    decimalSeparator = '.'
  } = options;

  if (typeof number !== 'number' || isNaN(number)) {
    throw new Error('Параметр должен быть числом');
  }

  // Округление
  const multiplier = Math.pow(10, decimals);
  let roundedNumber;

  switch (roundingType) {
    case 'floor':
      roundedNumber = Math.floor(number * multiplier) / multiplier;
      break;
    case 'ceil':
      roundedNumber = Math.ceil(number * multiplier) / multiplier;
      break;
    case 'trunc':
      roundedNumber = Math.trunc(number * multiplier) / multiplier;
      break;
    case 'round':
    default:
      roundedNumber = Math.round(number * multiplier) / multiplier;
  }

  // Разделение на целую и дробную части
  const [integerPart, decimalPart = ''] = roundedNumber.toString().split('.');

  // Форматирование целой части с разделителями
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);

  // Форматирование дробной части
  let formattedDecimal = '';
  if (decimals > 0) {
    const paddedDecimal = decimalPart.padEnd(decimals, '0');
    formattedDecimal = decimalSeparator + paddedDecimal;
  }

  return formattedInteger + formattedDecimal;
}
export default formatNumber
